import { title } from "../utils/title";

function to_json_py_var(key, var_name, var_type) {
  if (!var_type.includes("fields.")) {
    var_type = `fields.Nested(${var_type}Schema())`;
  }
  return {
    _class: `\n\t${var_name} = ${var_type}\n`,
    _class_: `\n\t\tself.${var_name} = ${var_name}\n`,
    _builder: `${to_py_var(var_name)}`
  };
}

function to_py_var(v, _class = false) {
  if (!v || !(typeof v === "string")) {
    throw "No Var";
  }

  v = v.replace(new RegExp(/[ ]+/g), "_");
  let variable = v.split("_");

  if (_class) {
    if (variable.length > 1) {
      variable =
        (!_class ? variable[0].toLowerCase() : title(variable[0])) +
        variable
          .slice(1)
          .map(x => title(x))
          .join("");
    } else {
      variable = !_class ? variable[0].toLowerCase() : title(variable[0]);
    }
  } else {
    if (variable.length > 1) {
      variable =
        variable[0].toLowerCase() +
        variable
          .slice(1)
          .map(x => title(x))
          .join("");
    } else {
      variable = variable[0].toLowerCase();
    }
  }

  return variable;
}

export function jsonMarshmallowParser(class_name, value) {
  let _type = "";
  let _classes = [];
  let _classes_ = [];
  let _variable_name;
  let _class_name;
  let _default;

  try {
    _variable_name = to_py_var(class_name);
    _class_name = to_py_var(class_name, true);
  } catch (e) {
    console.log(e);
  }

  if (value === null) {
    _type = "fields.Str()";
    _default = '""';
  } else if (typeof value === "string") {
    _type = "fields.Str()";
    _default = '""';

    if (
      value.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      _type = "fields.Email()";
    }
    // Check if string is email and set type as fields.Email(), same for Url
  } else if (typeof value === "boolean") {
    _type = "fields.Boolean()";
    _default = "true";
  } else if (typeof value === "number") {
    if (value % 1 === 0) {
      _type = "fields.Int()";
      _default = "0";
    } else {
      _type = "fields.Float()";
      _default = "0.0";
    }
  } else if (typeof value === "object") {
    if (Array.isArray(value)) {
      if (value.length === 0 || !value[0]) {
        _type = "fields.List()";
        _default = "[]";
      } else {
        const { _o_type, _o_classes, _o_classes_ } = jsonMarshmallowParser(
          _variable_name,
          value[0]
        );

        if (!_o_type.includes("fields.")) {
          _type = `fields.List(fields.Nested(${_o_type}Schema()))`;
        } else {
          _type = `fields.List(${_o_type})`;
        }
        _default = "[]";
        if (_o_classes.length > 0) {
          _classes = [..._o_classes, ..._o_classes];
          _classes_ = [..._o_classes_, ..._o_classes_];
        }
      }
    } else {
      _type = _class_name;

      _default = `${_class_name}.Builder().build()`;
      let _o_class = `class ${_class_name}Schema(Schema):\n`;
      let _d_class = ``;
      let _o_builder_defaults = "";
      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const data = value[key];
          const {
            _o_type,
            _o_classes,
            _o_classes_,
            _o_variable_name
          } = jsonMarshmallowParser(key, data);
          const { _class, _class_ } = to_json_py_var(
            key,
            _o_variable_name,
            _o_type,
            false
          );
          _o_class += _class;
          _d_class += _class_;

          _o_builder_defaults += `${
            _o_builder_defaults ? "," : ""
          }${_o_variable_name}`;
          if (_o_classes.length > 0) {
            _classes = [..._classes, ..._o_classes];
            _classes_ = [..._classes_, ..._o_classes_];
          }
        }
      }

      _classes.push(
        `${_o_class}\n\n\t@post_load\n\tdef make_${_class_name.toLowerCase()}(self, data, **kwargs):\n\t\treturn ${_class_name}(**data)`.replace(
          /\n\s*\n/g,
          "\n"
        )
      );
      _classes_.push(
        `class ${_class_name}:\n\n\tdef __init__(self,${_o_builder_defaults}):\n${_d_class}`.replace(
          /\n\s*\n/g,
          "\n"
        )
      );
    }
  }

  return {
    _o_type: _type,
    _o_default: _default,
    _o_variable_name: _variable_name,
    _o_classes: [...new Set(_classes)],
    _o_classes_: [...new Set(_classes_)]
  };
}
